const initState = [];

const studentsFree = (state = initState, action) => {
  switch (action.type) {
    case 'STUDENT_LIST_FREE':
      console.log(`STUDENT_LIST_FREE`);
      return action.payload;
    default:
      return state;
  }
};

export default studentsFree;
